/**
 * @jest-environment jsdom
 */
import {createSelector} from 'reselect';
import {initialState} from './reducer';

const selectState = (state) => state.GLASFASER_REGISTRATION || initialState;

const selectLoading = () => createSelector(selectState, state => state.loading);
const selectError = () => createSelector(selectState, state => state.error);
const selectInitRegistrationForm = () => createSelector(selectState, state => state.initRegistrationForm);
const selectRegistrationData = () => createSelector(selectState, state => state.registrationData);
const selectResponseData = () => createSelector(selectState, state => state.responseData);

export {selectLoading, selectError, selectInitRegistrationForm, selectRegistrationData, selectResponseData};
